// tlc.utils.eventQueue replacement

import { TLCLogger } from "../logger";
import { TLCEventManager } from "./EventManager";


export const EventQueue = (function() {

	var
		/**
		 * Total event count
		 * @type {number}
		 * @private
		 */
		totalItems = 0,
		/**
		 * Total number of completed events
		 * @type {number}
		 * @private
		 */
		completedCount = 0,
		/**
		 * The events to process
		 * @type {Array.<tlc.models.EventQueue.EventData>}
		 * @private
		 */
		myCollectionOfEventData = [],
		/**
		 * The callback for when all events are completed
		 * @type {Function}
		 * @private
		 */
		myCallback = null,
		/**
		 * The callback for when theres a progress update
		 * @type {function(number, {number}, {number})}
		 * @param {number} percentageComplete
		 * @param {number} totalItems
		 * @param {number} completedCount
		 * @private
		 */
		myProgressCallback = null;

	/**
	 *
	 * @param {Array.<tlc.models.EventQueue.EventData>} collection
	 * @private
	 */
	var recursive = function (collection) {
		if (collection.length > 0) {
			execute( collection.shift() );
		} else {
			if (myProgressCallback) {
				myProgressCallback(100, totalItems, completedCount);
			}
			if (myCallback) {
				myCallback();
			}
		}
	};

	/**
	 * @private
	 */
	var updateProgressBar = function () {
		if (myProgressCallback) {
			completedCount++;
			var progress = Math.floor(completedCount / totalItems * 100);
			myProgressCallback(progress, totalItems, completedCount);
		}
	};

	/**
	 * @private
	 * @param {tlc.models.EventQueue.EventData} eventData
	 */
	var execute = function (eventData) {
		if (eventData.funcWithCallback) {
			eventData.funcWithCallback(function () {
				updateProgressBar();
				recursive(myCollectionOfEventData);
			});
		} else {
			try {
				eventData.eventToListen = eventData.eventToListen || eventData.eventToFire + "Response";
				TLCEventManager.fireEvent(eventData.eventToFire, eventData.payload);
				eventData.listenerGuid = TLCEventManager.addListener(eventData.eventToListen, function (event) {
					updateProgressBar();
					if (eventData.callback) {
						eventData.callback(event);
					}
					TLCEventManager.removeListener(eventData.eventToListen, eventData.listenerGuid);
					recursive(myCollectionOfEventData);
				});
			} catch (e) {
				TLCLogger.error("Error", e);
				throw e;
			}
		}
	};

	return {
		/**
		 * Kick of a batch <b>synchronous</b> events
		 * @param {Array.<tlc.models.EventQueue.EventData>} collectionOfEventData
		 * @param {Function} callback optional callback for when all events are complete
		 * @param {function(number, number, number)=} progressCallback optional callback to get a % of completed events
		 */
		createQueue: function (collectionOfEventData, callback, progressCallback) {
			myCollectionOfEventData = collectionOfEventData;
			totalItems = myCollectionOfEventData.length;
			myCallback = callback;
			myProgressCallback = progressCallback;
			completedCount = 0;
			recursive(myCollectionOfEventData);
		}
	};
})();
